const className = '.js--lang-redirect-event';

function setCookie(cname, cvalue, exdays) {
	const d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	const expires = 'expires=' + d.toUTCString() + ';';
	const domain = 'domain=.' + (document.domain.match(/[^\.]*\.[^.]*$/)[0]) + ';';
	const path = 'path=/;';
	document.cookie = cname + '=' + cvalue + '; ' + expires + path + domain;
}

export default function () {
	const link = document.querySelector(className);
	const langCode = link.dataset.lang;
	const langUrl = link.href;

	link.addEventListener('click', function (e) {
		e.preventDefault();
		setCookie('_vigbo_region', langCode, 365);
		window.location.href = langUrl;
	});
}



// WEBPACK FOOTER //
// ./app/blocks/footer/footer.js